export const SET_ACTIVE_MODAL_FULFILLED = 'SET_ACTIVE_MODAL_FULFILLED';
export const CLOSE_ALL_MODALS_FULFILLED = 'CLOSE_ALL_MODALS_FULFILLED';
